import React, { useState, useEffect } from 'react';
import BarVideos from 'echarts-for-react';
import { StatisticDataVO } from '@/types/camp/admin/statisticDataType';
import NoData from '@/components/noData';
import { Tooltip as AntTooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

interface Props {
  data?: StatisticDataVO;
}

const EchartsBarVideo: React.FC<Props> = ({ data }) => {
  const [options, setOptions] = useState<{}>();
  const [valueList, setValueList] = useState<string[]>([]);
  const [totalList, setTotalList] = useState<string[]>([]);
  const [dataHeight, setDataHeight] = useState<number>(0);

  useEffect(() => {
    if (data?.videoPlayRanking) {
      const newArr = data.videoPlayRanking.map((student) =>
        student.realName ? student.realName : student.username,
      );
      const totals = data.videoPlayRanking.map((student) =>
        ((student.totalDuration / data.allVideoTime) * 100).toFixed(2),
      );
      setValueList(newArr);
      setTotalList(totals);
    }
  }, [data?.videoPlayRanking]);

  useEffect(() => {
    if (valueList.length > 0 && totalList.length > 0) {
      const option = {
        grid: {
          left: '1%',
          containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: function (params: any) {
            if (params && params.length > 0) {
              const index = params[0].dataIndex;
              const value = valueList[index] || '未知';
              return `${value}<br/>完成度: ${totalList[index] || '0'}%`;
            }
            return '';
          },
        },
        yAxis: {
          type: 'category',
          data: valueList,
          axisLabel: {
            formatter: function (value: string) {
              if (value.length > 6) {
                return value.slice(0, 6) + '...';
              }
              return value;
            },
          },
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            label: {
              show: true,
              position: 'right',
              formatter: function (params: any) {
                let percent = params.value + '%';
                return percent;
              },
            },
            data: totalList,
            type: 'bar',
            barCategoryGap: '14',
            itemStyle: {
              color: '#4096FF',
            },
          },
        ],
      };
      setTimeout(function () {
        console.log(option);
        setOptions(option);
        data && setDataHeight(data?.videoPlayRanking.length * 36);
      }, 500);
    }
  }, [data?.videoPlayRanking, valueList, totalList]);

  return (
    <div
      className="com_cmap_card_box"
      style={{ marginBottom: 24, height: '100%', overflow: 'hidden' }}
    >
      <div className="com_card_title16 flex_1" style={{ marginBottom: 16 }}>
        <span>视频观看完成度排行</span>
        <AntTooltip placement="top" title="学员观看视频时长/视频总时长的排行">
          <QuestionCircleOutlined className="col808 f14" style={{ marginLeft: 4, marginTop: 2 }} />
        </AntTooltip>
      </div>
      {data?.videoPlayRanking && data?.videoPlayRanking.length > 0 ? (
        <div style={{ height: 370, overflowY: 'scroll' }}>
          {options && dataHeight && (
            <BarVideos
              option={options}
              style={{
                minHeight: 370,
                height: dataHeight,
                marginTop: '-50px',
              }}
            />
          )}
        </div>
      ) : (
        <NoData name="暂无数据" />
      )}
    </div>
  );
};

export default EchartsBarVideo;
